import React from 'react'
export function Loader(props) {
    return (
        <div className="pos-absolute width-100 height-100 dis-flex item-center content-center top-null left-null bdg-trw" style={{ ...props.style, zIndex: '100' }}>
            <img src="/assets/img/loading_cat.gif" width="250" />
        </div>
    )
}